import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import Modal from "react-modal";
import { selectUser } from "../../components/auth/auth.selector";
import HelmetWrapper from "../../HelmetWrapper";
import CommonStructured from "../../components/common-components/CommonStructured";
import { fetchExpenseCategoriesData } from "../../redux/hygiene-reducers/hygieneSlice";
import ExpenseCatLists from "../../components/expense-management/ExpenseCatLists";
import ModalHeadAndClose from "../../components/payouts-wtf/common/ModalHeadAndClose";
import ExpenseCatForm from "../../components/expense-management/ExpenseCatForm";

const ExpenseCategories = () => {
  const userInfoData = useSelector(selectUser);
  const dispatch = useDispatch();

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  // const iniAllFilter = {
  //   isActive: "",
  //   searchString: "",
  // };
  // const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
  };
  const [filters, setFilters] = useState(iniFilters);
  // const [searchFilterApplied, setSearchFilterApplied] = useState(false);
  const iniModvalues = {
    isModOpen: false,
    cardName: "",
    rowData: "",
  };
  const [modValues, setModValues] = useState(iniModvalues);

  const onCloseModal = () => {
    setModValues(iniModvalues);
  };

  function getExpenseCategories(filters) {
    dispatch(
      fetchExpenseCategoriesData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    getExpenseCategories(filters);
  }, [filters]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
    }));
  }, [isPage, pageLimit]);

  return (
    <HelmetWrapper title="WTF: Expense Categories">
      <Container className="bg-cloud-k px-50px gobal-container" fluid>
        <Modal
          isOpen={modValues.isModOpen}
          onRequestClose={onCloseModal}
          contentLabel="Modal"
          ariaHideApp={false}
        >
          {modValues.cardName === "add" || modValues.cardName === "edit" ? (
            <ExpenseCatForm
              userInfoData={userInfoData}
              rowData={modValues.rowData}
              isEdit={modValues.cardName === "edit"}
              closeModal={onCloseModal}
              callFunction={() => getExpenseCategories(filters)}
            />
          ) : modValues.cardName === "description" ? (
            <div
              className={`createNewCTOModalContainer ${
                modValues.cardName === "description" ? "mod-width-50p" : ""
              }`}
            >
              <ModalHeadAndClose
                title={`${modValues.cardName?.replace(/_/g, " ")}`}
                onClose={onCloseModal}
              />

              <div className="discussionModalMessage mt30">
                <p className="message">
                  {modValues.rowData?.description || "No Content Available"}
                </p>
              </div>
            </div>
          ) : null}
        </Modal>

        <Row>
          <Col>
            <CommonStructured
              pageHeading={"Expense Categories"}
              createBtnTxt={"+ Add New Category"}
              onClickCreateBtn={() =>
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  cardName: "add",
                }))
              }
              isReload={() => getExpenseCategories(filters)}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <ExpenseCatLists
              userInfoData={userInfoData}
              isPage={isPage}
              setIsPage={setIsPage}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
              setModValues={setModValues}
              callFunction={() => getExpenseCategories(filters)}
            />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default ExpenseCategories;
